const DataGrid_SX = {
    '.MuiDataGrid-columnSeparator': {
        display: 'none',
    },
    '&.MuiDataGrid-root': {
        border: 'none',
    },
    
    '& .MuiDataGrid-columnHeaderTitle':{
        textTransform:'uppercase',
        fontWeight: 600,
        color:"#1d1d1d",
        fontSize:'1.076rem'
    },
    '& .MuiDataGrid-cell':{
        fontSize:'1.076rem'
    },
    '& .MuiDataGrid-withBorderColor':{
        borderColor:"#e5e7eb"
    },
    // "& .MuiDataGrid-row:nth-of-type(odd)":{
    //     backgroundColor:'#f3f5f9'
    // },
    '& .MuiDataGrid-virtualScroller':{
        // minHeight:'300px'
    },
    '& .MuiDataGrid-overlayWrapper':{
        height:'100%',
        // position:'absolute'
    },
    '& .MuiDataGrid-overlayWrapperInner':{
        height:'100% !important',
    }
}

const SelectDropdown_SX = {
    '& .MuiSelect-select':{
        padding:'11px',
        textAlign:'start',
        
    },
    'fieldset':{
        borderColor:"#e1e3ea !important",
        borderRadius:'0.475rem'
    }
}
const ColumnButton_style={
    '&.MuiButtonBase-root':{
        color: "#96a3af",
        width:'44px',
        height:'44px',
        minWidth:'44px',
        border:'0',
        display:'flex',
        alignItems:'center',
        justifyContent:'center',
        background:"#f9f9f9"
    },
    '& .MuiButton-startIcon':{
        marginRight:'0'
    },
    '&:hover':{
        backgroundColor:"#f4f4f4"
    }
}

export {DataGrid_SX,SelectDropdown_SX, ColumnButton_style};